(function () {
  function pad2(value) {
    return value < 10 ? '0' + value : String(value);
  }

  var el = document.querySelector('[data-campaign-teaser]');
  if (!el) return;

  var revealAt = new Date(el.getAttribute('data-reveal-at')).getTime();
  if (isNaN(revealAt)) return;

  if (Date.now() >= revealAt) return;

  el.style.display = 'flex';
  document.documentElement.style.overflow = 'hidden';

  var countdownEl = el.querySelector('[data-teaser-countdown]');
  var redirectUrl = el.getAttribute('data-redirect-url');

  function tick() {
    var ms = revealAt - Date.now();
    if (ms <= 0) {
      if (redirectUrl) {
        window.location.href = redirectUrl;
      } else {
        window.location.reload();
      }
      return;
    }
    var d = Math.floor(ms / 86400000);
    var h = Math.floor((ms % 86400000) / 3600000);
    var m = Math.floor((ms % 3600000) / 60000);
    var s = Math.floor((ms % 60000) / 1000);
    if (countdownEl) {
      countdownEl.textContent = d + 'd ' + pad2(h) + 'h ' + pad2(m) + 'm ' + pad2(s) + 's';
    }
  }

  tick();
  setInterval(tick, 1000);

  var dismissButton = el.querySelector('[data-teaser-dismiss]');
  if (dismissButton) {
    dismissButton.addEventListener('click', function () {
      el.style.display = 'none';
      document.documentElement.style.overflow = '';
    });
  }
})();